module.exports = __webpack_public_path__ + "img/ski_place8.186bc898.png";